document.addEventListener('DOMContentLoaded', () => {
  const updateStockState = (qtyInput, addToCartBtn, maxQty) => {
    if (!qtyInput || !addToCartBtn) return;

    const qtyButtons = document.querySelectorAll('.qty-box button');
    const outOfStock = (Number(maxQty) || 0) <= 0;

    if (outOfStock) {
      qtyInput.value = 0;
      qtyInput.disabled = true;
      addToCartBtn.disabled = true;
      addToCartBtn.textContent = 'Out of stock';

      qtyButtons.forEach((btn) => {
        btn.disabled = true;
      });
    } else {
      qtyInput.disabled = false;
      addToCartBtn.disabled = false;
      addToCartBtn.textContent = 'Add to cart';

      qtyButtons.forEach((btn) => {
        btn.disabled = false;
      });
    }
  };
  const qtyInput = document.querySelector('.qty-box input');
  const qtyButtons = document.querySelectorAll('.qty-box button');
  const addToCartBtn = document.querySelector('.product-add-btn');

  if (qtyInput) {
    updateStockState(qtyInput, addToCartBtn, qtyInput.dataset.maxQty);
  }

  if (qtyInput && qtyButtons.length >= 2) {
    const minusBtn = qtyButtons[0];
    const plusBtn = qtyButtons[1];

    minusBtn.addEventListener('click', () => {
      const current = parseInt(qtyInput.value || '1', 10);
      qtyInput.value = Math.max(1, current - 1);
    });

    plusBtn.addEventListener('click', () => {
      const current = parseInt(qtyInput.value || '1', 10);
      const rawMax = parseInt(qtyInput.dataset.maxQty || '0', 10);
      const maxQty = rawMax > 0 ? rawMax : 9999;
      qtyInput.value = Math.min(maxQty, current + 1);
    });

    qtyInput.addEventListener('input', () => {
      let value = parseInt(qtyInput.value || '1', 10);
      const rawMax = parseInt(qtyInput.dataset.maxQty || '0', 10);
      const maxQty = rawMax > 0 ? rawMax : 9999;

      if (isNaN(value) || value < 1) value = 1;
      if (value > maxQty) value = maxQty;

      qtyInput.value = value;
    });
  }

  const mainImage = document.querySelector('.js-product-main-image');
  const thumbs = Array.from(document.querySelectorAll('.product-thumb'));
  const galleryPrev = document.querySelector('[data-product-gallery-prev]');
  const galleryNext = document.querySelector('[data-product-gallery-next]');
  let activeImageIndex = thumbs.findIndex((thumb) => thumb.classList.contains('active'));
  let galleryAutoplay;

  const selectGalleryImage = (index) => {
    if (!mainImage || !thumbs.length) return;

    activeImageIndex = (index + thumbs.length) % thumbs.length;
    const activeThumb = thumbs[activeImageIndex];
    mainImage.src = activeThumb.dataset.image;

    thumbs.forEach((thumb) => thumb.classList.remove('active'));
    activeThumb.classList.add('active');
    activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
  };

  const restartGalleryAutoplay = () => {
    if (galleryAutoplay) window.clearInterval(galleryAutoplay);
    if (thumbs.length > 1) {
      galleryAutoplay = window.setInterval(() => {
        selectGalleryImage(activeImageIndex + 1);
      }, 5000);
    }
  };

  thumbs.forEach((thumb, index) => {
    thumb.addEventListener('click', () => {
      selectGalleryImage(index);
      restartGalleryAutoplay();
    });
  });

  if (galleryPrev) {
    galleryPrev.addEventListener('click', () => {
      selectGalleryImage(activeImageIndex - 1);
      restartGalleryAutoplay();
    });
  }

  if (galleryNext) {
    galleryNext.addEventListener('click', () => {
      selectGalleryImage(activeImageIndex + 1);
      restartGalleryAutoplay();
    });
  }

  if (activeImageIndex < 0) activeImageIndex = 0;
  restartGalleryAutoplay();

  const imageDialog = document.querySelector('[data-product-image-dialog]');
  const imageDialogOpen = document.querySelector('[data-product-image-modal-open]');
  const imageDialogClose = document.querySelector('[data-product-image-modal-close]');
  const imageDialogImage = document.querySelector('[data-product-image-modal-image]');

  if (imageDialog && imageDialogOpen && imageDialogImage && mainImage) {
    imageDialogOpen.addEventListener('click', () => {
      imageDialogImage.src = mainImage.currentSrc || mainImage.src;
      imageDialogImage.alt = mainImage.alt;
      imageDialog.showModal();
    });

    if (imageDialogClose) {
      imageDialogClose.addEventListener('click', () => imageDialog.close());
    }

    imageDialog.addEventListener('click', (event) => {
      if (event.target === imageDialog) imageDialog.close();
    });
  }

  const optionButtons = document.querySelectorAll('.product-size-btn, .product-color-btn');
  const variantInput = document.querySelector("input[name='id']");
  const variantsJson = document.querySelector('.product-variants-json');
  const priceEl = document.querySelector('.js-product-price');
  const comparePriceEl = document.querySelector('.js-product-compare-price');
  const colorLabelEl = document.querySelector('.js-product-color-selected');

  if (optionButtons.length && variantInput && variantsJson) {
    const variants = JSON.parse(variantsJson.textContent || '[]');
    const selectedOptions = {};

    const allSoldOut = variants.length > 0 && variants.every((v) => Number(v.inventory_quantity || 0) <= 0);
    if (allSoldOut && qtyInput) {
      updateStockState(qtyInput, addToCartBtn, 0);
    }

    const findMatchingVariant = () => {
      return variants.find((variant) => {
        return Object.keys(selectedOptions).every((position) => {
          const value = selectedOptions[position];
          if (!value) return true;
          return variant['option' + position] === value;
        });
      });
    };

    const applyVariant = (matchingVariant) => {
      if (!matchingVariant) return;

      variantInput.value = matchingVariant.id;

      if (priceEl && matchingVariant.price_html) {
        priceEl.textContent = matchingVariant.price_html;
      }

      if (comparePriceEl) {
        if (matchingVariant.compare_at_price_html) {
          comparePriceEl.textContent = matchingVariant.compare_at_price_html;
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.textContent = '';
          comparePriceEl.style.display = 'none';
        }
      }

      if (qtyInput) {
        const availableQty = Number.parseInt(matchingVariant.inventory_quantity, 10);
        const maxQty = Number.isFinite(availableQty) ? availableQty : 9999;

        qtyInput.dataset.maxQty = maxQty;

        if (maxQty <= 0) {
          qtyInput.value = 0;
        } else {
          qtyInput.value = Math.max(
            1,
            Math.min(
              Math.max(parseInt(qtyInput.value || '1', 10), 1),
              maxQty
            )
          );
        }

        updateStockState(qtyInput, addToCartBtn, maxQty);
      }
    };

    optionButtons.forEach((button) => {
      if (button.dataset.available === 'false') {
        button.disabled = true;
      }

      button.addEventListener('click', () => {
        const isColor = button.classList.contains('product-color-btn');
        const groupSelector = isColor ? '.product-color-btn' : '.product-size-btn';

        document.querySelectorAll(groupSelector).forEach((b) => b.classList.remove('active'));
        button.classList.add('active');

        const position = button.dataset.optionPosition;
        const value = button.dataset.value;
        selectedOptions[position] = value;

        if (isColor && colorLabelEl) {
          colorLabelEl.textContent = value;
        }

        applyVariant(findMatchingVariant());
      });
    });

    const activeButtons = document.querySelectorAll('.product-size-btn.active:not(:disabled), .product-color-btn.active:not(:disabled)');
    activeButtons.forEach((button) => button.click());
  }
});
